import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            资深穿搭达人为你精选的优质内容
          </p>
        </div>
        <Link
          to="/category/jingdian-shenshi"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {featured.map((article, index) => (
          <ArticleCard
            key={article.slug}
            article={article}
            variant={index === 0 ? 'featured' : 'default'}
          />
        ))}
      </div>
    </section>
  );
}